import React from 'react';
import { Icon as IconRoot } from './styles';
import { ContextMenu } from '../../ContextMenu/ContextMenu';
import Button from '../../Button/Button';
import { cx } from '@linaria/core';
import Icon from '../../Icon/Icon';
function TeaserContextMenu({ items, onIconClick, isInWatchlist }) {
    /** Variables */
    const contextMenuItems = items.map((button) => {
        return { ...button, type: undefined };
    });
    /** JSX */
    return (React.createElement("div", { className: cx(IconRoot.base, isInWatchlist && IconRoot.isInWatchlist), onClick: onIconClick },
        React.createElement(ContextMenu, { items: contextMenuItems },
            React.createElement(Button, { isIconOnly: true, text: "Mehr", iconLeft: React.createElement(Icon, { name: "more", type: "solid" }) }))));
}
export default TeaserContextMenu;
